import { COUNTRY_CODE_API } from "../../utilities";
import { baseSplitApi } from "./../baseApi";

let listOfCountriesPath = COUNTRY_CODE_API
export const countriesListApi = baseSplitApi.injectEndpoints({
    endpoints: (build) => ({
        getAllCountriesAndPhoneCode: build.query({
            query: () => {
                return {
                    url: listOfCountriesPath
                }
            },
        })
    }),
    overrideExisting: false
})

export const { useGetAllCountriesAndPhoneCodeQuery } = countriesListApi



